module.exports = __webpack_public_path__ + "static/media/AshevilleBrewingplanetmuralstudio.3eebc7de.webp";